import { toDateInput } from 'helpers/date';

export const defaultState = {
  certId: null,
  deltaClass: null,
  status: '',
  organization: null,
  validTill: null,
  dateDeltaCertificate: null,
};

const SET_RENEW_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setRenewDataCreator = (payload) => ({ type: SET_RENEW_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_RENEW_DATA) {
    const newDateDeltaCertificate = toDateInput(action.payload.validTill) || new Date();
    newDateDeltaCertificate.setDate(newDateDeltaCertificate.getDate() + 1);
    const newValidTill = new Date(newDateDeltaCertificate);
    newValidTill.setFullYear(newValidTill.getFullYear() + 5);
    newValidTill.setDate(newValidTill.getDate() - 1);
    return {
      ...state,
      ...action.payload,
      status: 'Renew',
      organization: action.payload.organization?.id,
      dateDeltaCertificate: newDateDeltaCertificate,
      validTill: newValidTill,
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
